import axios from "axios";
import AwsAxios from "./AwsAxios";

const BASE_URL = "https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod";
// const REFRESH_URL = 'https://accounts.coursera.org/oauth2/v1/token';

const Coursera = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

Coursera.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken");
    let courseraToken = localStorage.getItem("coursera_access_token");
    console.log("🚀 ~ courseraToken:", courseraToken);
    if (!courseraToken) {
      const refreshResponse = await AwsAxios.get(`${BASE_URL}/access-token`);
      // console.log(refreshResponse, " = refreshResponse:Coursera");
      const { access_token } = refreshResponse.data;
      courseraToken = `Bearer ${access_token}`;
    }
    // console.log(token, " = token in AwsAxios:Config");
    if (token) {
      // config.headers["Content-Type"] = "application/json"
      config.headers.Authorization = token;
      config.headers["coursera-token"] = courseraToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Coursera.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log(error, " = errorrrrrr:courseraAxiosConfig");
    const originalRequest = error.config;
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await AwsAxios.get(`${BASE_URL}/access-token`);
        console.log(refreshResponse, " = refreshResponse:Coursera");
        const { access_token } = refreshResponse.data;
        console.log(access_token, " = access_token_config_file");
        localStorage.setItem("coursera_access_token", `Bearer ${access_token}`);
        axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        originalRequest.headers["Authorization"] = `Bearer ${access_token}`;

        return Coursera(originalRequest);
      } catch (refreshError) {
        console.error("Error refreshing token: ", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default Coursera;
